<template>
  <div class="elite-content" v-bind:class="[isActive ? 'unfold' : 'fold']">
    <notifications></notifications>
    <div
      class="elite-content_sidebar"
      :class="{ 'has-level2': $route.meta.hasLevel2 }"
      ref="sidebar"
    >
      <div
        class="elite-content_sidebar_level1"
        v-bind:class="[
          isActive ? 'unfold' : 'fold',
          shouldFold ? 'shouldFold' : ' ',
        ]"
      >
        <div class="elite-content_sidebar_level1_logo">
          <router-link :to="{ name: 'Dashboard' }">
            <span class="logo">
              <img src="/img/go-vpt-logo.png" alt="logo" />
            </span>
            <span class="logo-icon">
              <img src="/img/vpt-logo.svg" alt="logo-icon" />
            </span>
          </router-link>
          <!-- <button @click="toggleClass()">
            <i class="far fa-arrow-left"></i>
          </button> -->
        </div>
        <div class="elite-content_sidebar_level1_menu">
          <main-navbar-apps></main-navbar-apps>
        </div>
        <div class="elite-content_sidebar_level1_user">
          <div class="elite-content_sidebar_level1_user_avatar">
            <div class="elite-content_sidebar_level1_user_avatar_image">
              <base-dropdown
                v-if="me"
                title-classes="btn dropdown-button"
                menu-on-top
                :has-toggle="false"
              >
                <template slot="title">
                  <div class="user-dropdown">
                    <span>
                      {{ `${me.firstname.charAt(0)}${me.lastname.charAt(0)}` }}
                    </span>
                    <img
                      v-if="me.profile_image"
                      :src="me.profile_image"
                      alt="profile-picture"
                    />
                    <img v-else src="/img/vpt-logo.svg" alt="profile-picture" />
                  </div>
                </template>
                <li>
                  <router-link to="/me" v-if="me">
                    <i class="fal fa-user"></i>
                    <span>{{ `${me.firstname + " " + me.lastname}` }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/me?tab=locations" v-if="me">
                    <i class="ni ni-map-big"></i>
                    <span>
                      {{ $t("COMMON.MY_LOCATIONS") }}
                    </span>
                  </router-link>
                </li>
                <li>
                  <button @click="logout">
                    <i class="fal fa-sign-out"></i>{{ $t("COMMON.LOGOUT") }}
                  </button>
                </li>
              </base-dropdown>
            </div>
          </div>
          <div class="elite-content_sidebar_level1_user_lang">
            <div class="elite-content_sidebar_level1_user_lang_selected">
              <base-dropdown
                title-classes="btn btn-sm btn-neutral mr-0"
                menu-on-left
                :has-toggle="false"
                menuClasses="lang-switcher"
              >
                <template slot="title">
                  <img
                    ref="lang"
                    :src="`/img/locale_flags/${$i18n.locale}.svg`"
                    :alt="$i18n.locale"
                    @click="getPosition"
                  />
                </template>
                <li v-for="lang in languages" :key="lang">
                  <a
                    class="dropdown-item"
                    v-bind:class="{ active: lang === $i18n.locale }"
                    @click="selectLang(lang)"
                  >
                    <img :src="`/img/locale_flags/${lang}.svg`" :alt="lang" />
                    <span>{{ lang }}</span>
                    <i class="fal fa-check"></i>
                  </a>
                </li>
              </base-dropdown>
            </div>
          </div>
          <div class="elite-content_sidebar_level1_user_menu">
            <ul>
              <li class="notifications">
                <router-link to="/notifications" v-if="me">
                  <span class="notifications_wrapper">
                    <notifications-count />
                  </span>
                  <i class="far fa-bell"></i>
                </router-link>
              </li>
              <li>
                <a href="#"><i class="far fa-envelope"></i></a>
              </li>
              <li>
                <a href="#"><i class="far fa-question-circle"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <router-view name="SidebarSecondLevelMenu"></router-view>
    </div>
    <div
      class="elite-content_body"
      :style="{ width: `calc( 100% - ${width}px)`, marginLeft: width + 'px' }"
    >
      <button class="close-button" @click="toggleClass()">
        <img src="../../../../public/img/expand.svg" alt="icon" />
      </button>
      <div class="elite-content_body_inner">
        <router-view></router-view>
      </div>
    </div>
    <div class="elite-content_bot">
      <button>
        <i class="fal fa-comments"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";
import { loadLanguageAsync } from "@/plugins/i18n";
import MainNavbarApps from "./partials/MainNavbarApps.vue";
import NotificationsCount from "./partials/NotificationsCount.vue";
import Pusher from "pusher-js";

export default {
  components: { MainNavbarApps, NotificationsCount },

  mixins: [],

  data() {
    return {
      isActive: false,
      languages: ["fr", "en"],
      width: null,
      observer: null,
      positionTop: 0,
      positionLeft: 0,
      shouldFold: false,
    };
  },

  methods: {
    toggleClass(event) {
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },

    selectLang(lang) {
      loadLanguageAsync(lang);
    },

    sidebarObserver() {
      const box = this.$refs.sidebar,
        vm = this,
        config = {
          attributes: true,
          childList: true,
        };
      const elementToObserve = document.querySelector(".elite-content_sidebar");
      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          vm.width = entry.contentRect.width;
        });
      });
      observer.observe(elementToObserve, config);
      this.observer = observer;
    },

    getPosition() {
      this.positionTop = this.$refs["lang"].getBoundingClientRect().top;
      this.positionLeft = this.$refs["lang"].getBoundingClientRect().left;
      const dropdown = document.querySelector(".lang-switcher");
      if (this.isActive === false) {
        dropdown.style.cssText = `
          top: ${this.positionTop - 40}px;
          left: ${this.positionLeft}px;
        `;
      } else {
        dropdown.style.cssText = `bottom: 0; left: 0;`;
      }
    },

    menuLinkClickHandler() {
      this.shouldFold = true;
      setTimeout(
        function () {
          this.shouldFold = false;
        }.bind(this),
        1000
      );
    },

    menuHoverObserver() {
      const firstMenuLinks = document.querySelectorAll(
        ".elite-content_sidebar_level1_menu_wrapper > ul > li > a"
      );
      for (const menuLink of firstMenuLinks) {
        menuLink.removeEventListener("click", this.menuLinkClickHandler);
      }
      for (const menuLink of firstMenuLinks) {
        menuLink.addEventListener("click", this.menuLinkClickHandler);
      }
    },

    logout() {
      try {
        this.$store.dispatch("logout");
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
      }
    },
    initPusher(userId) {
      const pusher = new Pusher("0e2483432ca948cf5a14", {
        cluster: "mt1",
      });

      const channel = pusher.subscribe(`private-user.${userId}`);

      channel.bind("App\\Events\\BatchFinished", (data) => {
        console.log("BatchFinished reçu :", data);

        this.$notify({
          type: "success",
          message: this.$t("PROPERTIES.ESTIMATION_CREATED"),
        });
      });

      console.log("Pusher prêt pour utilisateur :", userId);
    },
  },

  async mounted() {
    this.sidebarObserver();
    
  },

  computed: {
    ...mapGetters("profile", { me: "me" }),
  },

  watch: {
    me: {
      immediate: true,
      handler: debounce(function (val) {
        this.menuHoverObserver();
        //this.initPusher(val.id);
      }),
      deep: true,
    },
  },
};
</script>
